import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormWrapper from '../../../../../library/form/components/FormWrapper';
import FormInput from '../../../../../library/form/components/FormInput';

const ProdIOTRetOPRow = (props) => {
    const { formObject, index, rowKey } = props;

    return (
        <ul className="uiDPEditLine">
            <li className="uiColumnCenter uiColumn50">
                <span>{index}</span>
            </li>
            <li className="uiColumnCenter uiColumn70">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "id" }} />
            </li>
            <li className="uiColumnCenter uiColumn200">
                <FormInput formObject={formObject} className="uiSpacerH5" rowKey={rowKey}
                    useValF={1}
                    action={{
                        InputType: "input", actionId: "refresh", paramName: 'actualItem',
                        actionParam: { actionType: "updateRetOpItem" }
                    }} />
            </li>
            <li className="uiColumnCenter uiColumn100">
                <FormInput format="#" formObject={formObject} rowKey={rowKey} className="uiInput uiColumn50"
                    action={{ InputType: "ac", paramName: "unit1", 
                            actionId:"refresh", acMethod: "CategoryDetail", acDepCtrl: { "dparam": "28" },
                            actionParam: { actionType: "updateRetOpItem" }
                        }}
                />
                <FormInput format="#" formObject={formObject} rowKey={rowKey} className="uiInput uiColumn50"
                    action={{ InputType: "ac", paramName: "unit2", 
                            actionId:"refresh", acMethod: "CategoryDetail", acDepCtrl: { "dparam": "28" },
                            actionParam: { actionType: "updateRetOpItem" } }}
                />
            </li>
            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn100" headerKey="viewConfig"
                action={{ paramName: "variation1Name" }} >
                <FormInput formObject={formObject} rowKey={rowKey} className="uiInput uiColumn100"
                        action={{
                            InputType: "ac", paramName: "variation1", acMethod: "ProdVariation1",
                            actionId:"refresh",
                            acDepCtrl: { 'dparam': '%dataList.valLDT', 'dId': '%dataList.dId'},
                            actionParam: { actionType: "updateRetOpItem" }
                        }}
                />
            </FormWrapper>
            <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn100" headerKey="viewConfig"
                action={{ paramName: "variation2Name" }} >
                <FormInput formObject={formObject} rowKey={rowKey} className="uiInput uiColumn100"
                    action={{
                        InputType: "ac", paramName: "variation2", acMethod: "ProdVariation2",
                        actionId:"refresh",
                        acDepCtrl: { 'dparam': '%dataList.valLDT', 'dId': '%dataList.dId', 'variation1': '#variation1'},
                        actionParam: { actionType: "updateRetOpItem" }
                    }}
                />
            </FormWrapper>
            <li className="uiColumnCenter uiColumn150">
                <div style={{ float: "left" }}>
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "qtyReturned" }} />
                    <FormInput formObject={formObject} className="uiWidth55 uiSpacerH5" rowKey={rowKey}
                        action={{
                            InputType: "input", actionId: "refresh", paramName: 'qtyReturn1',
                            actionParam: { updateQty: "1" }
                        }} />
                    <FormInput formObject={formObject} className="uiWidth55" rowKey={rowKey}
                        action={{
                            InputType: "input", actionId: "refresh", paramName: 'qtyReturn2',
                            actionParam: { updateQty: "1" }
                        }} />
                </div>
            </li>
            <li className="uiColumnCenter uiColumn150">
                <FormInput formObject={formObject} className="uiSpacerH5" rowKey={rowKey}
                    action={{
                        InputType: "input", actionId: "refresh", paramName: 'remark',
                        actionParam: { actionType: "updateRetOpItem" }
                    }} />
            </li>
        </ul>
    )
}

export default ProdIOTRetOPRow
